import ApiTokenRefresh from '@js/api/token-refresh'
import store from '@store/store'

async function bootstrapAuth () {
  const tokenNotExpired = (
    !store.getters['auth/accessTokenExpired'] &&
    !store.getters['auth/refreshTokenExpired'] &&
    store.state.auth.refresh
  );

  if (tokenNotExpired) {
    try {
      const payload = {
        refresh: store.state.auth.refresh,
      };
      const api = await new ApiTokenRefresh();
      const res = await api.post(payload);
      await store.commit('auth/setAccessToken', res.data);
    } catch (error) {
      console.error(error);
      throw 'auth-utils.bootstrapAuth error.';
    }
  }
}

async function refreshAccessToken () {
  try {
    const payload = {
      refresh: store.state.auth.refresh,
    };
    const api = await new ApiTokenRefresh();
    const res = await api.post(payload);
    const tokenPair = await {
      access: res.data.access,
      accessExpiresIn: res.data.accessExpiresIn,
    }
    await store.commit('auth/setAccessToken', tokenPair);
  } catch (error) {
    console.error(error);
  }
}

export {
  bootstrapAuth,
  refreshAccessToken,
};
